import { createSelector } from 'reselect'

export const getAllContent = (state: any) => {
  return state
}

export const getAllCategories = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    let filter = state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'category',
    )
    filter = filter.sort((a: any, b: any) =>
      a.fields.order > b.fields.order ? 1 : -1,
    )
    return filter
  }
  return undefined
})

export const getAllProducts = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'product',
    )
  }
  return undefined
})

export const getAllBanner = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'banner',
    )
  }
  return undefined
})

export const getAllCompanies = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'brand',
    )
  }
  return undefined
})

export const getAllTestimonies = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'viskiptavinatal',
    )
  }
  return undefined
})

export const getAllUmOkkurSecondTestimony = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === 'umOkkurSeinnaViskiptavinatal',
      )
    }
    return undefined
  },
)

export const getAllUmOkkurTestimonies = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === 'umOkkurViskiptavinatal',
      )
    }
    return undefined
  },
)
export const getAllStaff = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'staff',
    )
  }
  return undefined
})

export const getAllVorur = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'vrur',
    )
  }
  return undefined
})

export const getAllVorurBanner = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'productBanner',
    )
  }
  return undefined
})

export const getAllVorurMyndir = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'vrurMyndir',
    )
  }
  return undefined
})

export const getAllVoruMerki = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'vrur',
    )
  }
  return undefined
})

export const getAllFramleidendur = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === 'fyrirtki',
      )
    }
    return undefined
  },
)

export const getAllNewFrom = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'nttFr',
    )
  }
  return undefined
})

export const getAllInstagram = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'instagram',
    )
  }
  return undefined
})

export const getUmOkkur = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'umOkkurBanner',
    )
  }
  return undefined
})

export const getContactUs = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'contactUsBanner',
    )
  }
  return undefined
})

export const getAllAnnouncements = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === 'announcement',
      )
    }
    return undefined
  },
)
export const getAllEmployees = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'employees',
    )
  }
  return undefined
})

export const getAllFooter = createSelector(getAllContent, (state: any) => {
  if (state.content !== undefined && state.content.items) {
    return state.content.items.filter(
      (x: any) => x.sys.contentType.sys.id === 'footer',
    )
  }
  return undefined
})
/*export const getAllFlokkarProduct = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === "employees"
      );
    }
    return undefined;
  }
);*/

/*export const getAllFlokkarProductBanner = createSelector(
  getAllContent,
  (state: any) => {
    if (state.content !== undefined && state.content.items) {
      return state.content.items.filter(
        (x: any) => x.sys.contentType.sys.id === "umOkkurBanner"
      );
    }
    return undefined;
  }
);*/

/*export const getAllContent = createSelector(getAllContents, (content: any) => {
  if (content) {
    // return content.filter((x: any) => x.actionType.id !== 'flipp'); // gerum selectora hér til að fá allskonar hluti
    return content;
  }
  return undefined;
});*/



// WEBPACK FOOTER //
// ./src/reducers/selectors.ts